@if ({ isLoading: loadingService.isSpinnerActive$('loadD365Connection') | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-replicator-page-header [title]="title"></coso-replicator-page-header>
@if (isRunning) {
<alert type="warning">
  <coso-alert-message>You can only modify the content of this page once the replication process is stopped.</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}
<form [formGroup]="formGroup" (ngSubmit)="saveConnection()">
  <div class="card card-cns mb-3">
    <div id="header" class="card-header">Dynamics 365</div>
    <div id="body" class="card-body">
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <coso-dynamics-365-connection-form
        [viewMode]="isConfigured ? (isReadOnly ? ViewMode.View : ViewMode.Edit) : ViewMode.Create"
        [isSaaS]="isSaaS"
        [connectionFormGroup]="formGroup"
        [formText]="formText"
        [showUseDefaultCertificate]="true"
        [showAzureEndpoint]="false"
        [showGrantType]="true"
        [supportsManagedIdentity]="!isSaaS"
        [supportsExternalAzureAdAppInSaaS]="true"
      >
      </coso-dynamics-365-connection-form>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-lg-12">
      <div class="d-flex justify-content-between">
        <a class="btn btn-dark" [routerLink]="['/', 'configuration', instanceId, 'connections']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Connections list</a>
        @if (!isReadOnly) {
        <button type="submit" class="btn btn-primary col-2" [disabled]="formGroup.invalid || (dynamics365ConnectionHandler.isTestingConnection$ | async)">Save</button>
        }
      </div>
    </div>
  </div>
</form>
} }

<ng-template #validationRef>
  The following settings are not compatible with your new organization URL and must be removed:
  <ul>
    @for (incompatibility of incompatibilities; track incompatibility) {
    <li>{{ incompatibility }}</li>
    }
  </ul>
  <p>Would you like to remove them and continue?</p>
  <strong class="text-primary">Please note that you will not be able to recover them later.</strong>
</ng-template>

<ng-template #organizationUrlPopover>
  <p>The URL of your Dynamics 365 instance.</p>
  Examples:
  <ul>
    <li>https://OrganizationName.api.crm4.dynamics.com/</li>
    <li>https://CrmName.contoso.com/OrganizationName/</li>
  </ul>
</ng-template>
